export default function Metrics({ data }) {
  return (
    <section className="mb-12">
      <h2 className="text-2xl font-semibold text-gray-900  text-center">Overall Event Metrics</h2>
      <h3 className="text-lg font-medium text-gray-900 mb-4">
            Registered Voters: <span>{data.registeredVoters.toLocaleString()}</span>
          </h3>
    </section>
  );
}
